export const RESET = 'EXCMAGREEMENTDEVICE_LIST_RESET'
export const SET_ITEMS = 'EXCMAGREEMENTDEVICE_LIST_SET_ITEMS'
export const SET_ERROR = 'EXCMAGREEMENTDEVICE_LIST_SET_ERROR'
export const SET_VIEW = 'EXCMAGREEMENTDEVICE_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXCMAGREEMENTDEVICE_LIST_TOGGLE_LOADING'
